import { render } from "./ProductOptions.vue?vue&type=template&id=7640ae12&scoped=true"
import script from "./ProductOptions.vue?vue&type=script&lang=js"
export * from "./ProductOptions.vue?vue&type=script&lang=js"

import "./ProductOptions.vue?vue&type=style&index=0&id=7640ae12&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7640ae12"]])

export default __exports__